import React from 'react';
import './Heading.css';

import { FaDroplet } from 'react-icons/fa6';

import { images } from '../../constants';



const Heading = ({ title, subTitle = '', sideHeading = false, linear = false }) => {

  return (
    <div className={`heading ${sideHeading ? 'sideheading' : ''} ${linear ? 'linear-bg' : ''}`}>

      {/* Render the subTitle section only if subTitle is provided */}
      {subTitle && (
        <div className="sub">

          {/* Render the left icon only when sideHeading is false */}
          {!sideHeading && <FaDroplet className="icon" />}

          {/* Display the subtitle text */}
          <span>{subTitle}</span>

          {/* Always show the right icon */}
          <FaDroplet className="icon" />

        </div>
      )}

      <h2>{title}</h2> {/* Display the title */}

      <img src={images.heading} alt='Heading' /> {/* Wave image */}

    </div>
  );
};

export default Heading;